import Vue from "vue";
import Router from "vue-router";
import home from "../components/smartCity/Home.vue";
import homebak1 from "../components/smartCity/homebak1.vue";
import smartElectricity from "../components/smartElectricity/smarElectricity";
import city from "../components/smartElectricity/city.vue";
import login from "../components/login/login.vue";
import xed_login from "../components/login/xed_login/xed_login.vue";
import intermediate from "../components/intermediate/intermediate.vue";
import report from "../components/report/report.vue";
import energy from "../components/report/energy/energy.vue";
import abnormal from "../components/report/abnormal/abnormal.vue";
import electricity from "../components/report/electricity/electricity.vue";
import operation_log from "../components/report/operation_log/operation.vue";
import deviceMoney from "../components/report/deviceMoney/deviceMoney.vue";

// 安全用气
import BigScreen from "../components/useGas/bigScreen/index.vue";
import UseGasModel from "../components/useGas/index.vue";
import MapHomeModel from "../components/useGas/views/map_home/index.vue";
import AreaModel from "../components/useGas/views/area/index.vue";
import UserTypeModel from "../components/useGas/views/userType/index.vue";
import UserModel from "../components/useGas/views/user/index.vue";
import DeviceModel from "../components/useGas/views/device/index.vue";
import AlertModel from "../components/useGas/views/alert/index.vue";
import AlarmModel from "../components/useGas/views/alarm/index.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: home
    },
    {
      path: "/SmartFarmland",
      name: "homebak1",
      component: homebak1
    },
    {
      path: "/smartElectricity",
      name: "smartElectricity",
      component: smartElectricity
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/xed_login",
      name: "xed_login",
      component: xed_login
    },
    {
      path: "/intermediate",
      name: "intermediate",
      component: intermediate
    },
    {
      path: "/report",
      name: "report",
      component: report,
      children: [
        {
          path: "/energy",
          name: "energy",
          component: energy
        },
        {
          path: "/abnormal",
          name: "abnormal",
          component: abnormal
        },
        {
          path: "/electricity",
          name: "electricity",
          component: electricity
        },
        {
          path: "/operation_log",
          name: "operation_log",
          component: operation_log
        },
        {
          path: "/deviceMoney",
          name: "deviceMoney",
          component: deviceMoney
        }
      ],
      redirect: "/energy"
    },
    {
      path: "/bigScreen",
      name: "bigScreen",
      component: BigScreen
    },
    {
      path: "/use_gas",
      name: "useGas",
      component: UseGasModel,
      children: [
        {
          path: "/map_home",
          name: "map_home",
          component: MapHomeModel
        },
        {
          path: "/area",
          name: "area",
          component: AreaModel
        },
        {
          path: "/user_type",
          name: "userType",
          component: UserTypeModel
        },
        {
          path: "/user",
          name: "user",
          component: UserModel
        },
        {
          path: "/device",
          name: "device",
          component: DeviceModel
        },
        {
          path: "/alert",
          name: "alert",
          component: AlertModel
        },
        {
          path: "/alarm",
          name: "alarm",
          component: AlarmModel
        }
      ],
      redirect: "/map_home"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js